import { TFunction } from 'i18next';
import { SsoIntegrationProviderPresetEnum } from 'graphql-common';

export default function getSsoPresetLabel(
  preset: SsoIntegrationProviderPresetEnum,
  t: TFunction,
): string {
  const labels: Record<SsoIntegrationProviderPresetEnum, string> = {
    [SsoIntegrationProviderPresetEnum.Okta]: t('okta'),
    [SsoIntegrationProviderPresetEnum.Google]: t('google'),
    [SsoIntegrationProviderPresetEnum.Microsoft]: t('microsoft'),
    [SsoIntegrationProviderPresetEnum.Auth0]: t('auth0'),
    [SsoIntegrationProviderPresetEnum.Onelogin]: t('onelogin'),
    [SsoIntegrationProviderPresetEnum.Custom]: t('custom'),
  };
  return labels[preset] || preset;
}
